const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '智能CDN加速技术，全网节点覆盖，视频秒开不等待，播放过程零缓冲。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: 'HTTPS加密传输，无弹窗广告干扰，纯净观影环境，保护您的隐私安全。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '电脑、平板、手机全平台兼容，自适应屏幕尺寸，随时随地畅享高清影视。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    desc: '24小时不间断内容同步，热播剧集第一时间上线，追剧永远快人一步。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费',
    desc: '无需注册、无需付费、无需会员，所有内容开放观看，真正零门槛观影体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">平台特色</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">为什么选择桃花视频？五大优势为你保驾护航</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-lg p-5 text-center group cursor-default transition-all hover:bg-background-200"
            >
              <span className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}